import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { withRouter } from 'react-router-dom';
import { validateEmail } from '../../common/globalUtils';
import { ValidatedInput } from '../shared-components';
import SignUpResult from './components/SignUpResult';

const mockSignUpResult = text => {
  return text.length > 0;
};

const ORGANIZATION = 'organization';
const EMAIL = 'email';

const initialState = {
  organization: '',
  email: '',
  adminName: '',
  designation: '',
  isSubmitting: false,
  isShowResult: false,
  isSubmitSuccess: false,
  error: {},
};

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
    this.setFormValue = this.setFormValue.bind(this);
  }

  componentDidMount() {
    ReactGA.pageview('/signup');
  }

  setFormValue = event => {
    let { error } = this.state;
    const key = event.target.name;
    const value = event.target.value;
    delete error[key];
    this.setState({
      [key]: value,
    });
  };

  isValidEmail = () => {
    return validateEmail(this.state.email);
  };

  isValidOrganization = () => {
    return this.state.organization.trim().length > 0;
  };

  validateAndGetFormErrors = () => {
    let { error } = this.state;
    if (!this.isValidOrganization()) {
      error[ORGANIZATION] = true;
    }
    if (!this.isValidEmail()) {
      error[EMAIL] = true;
    }
    return error;
  };

  isValidForm = error => {
    return !Object.keys(error).length;
  };

  isDisableSubmitBtn = () => {
    const { isSubmitting, error } = this.state;
    return isSubmitting || !this.isValidForm(error);
  };

  getSubmissionResult = () => {
    return mockSignUpResult(this.state.designation);
  };

  isActiveSubmitBtn = () => {
    const { organization, email } = this.state;
    return organization.trim().length > 0 && email.trim().length > 0;
  };

  signUpSubmit = event => {
    this.setState({
      isSubmitting: true,
    });
    event.preventDefault();
    const error = this.validateAndGetFormErrors();
    if (this.isValidForm(error)) {
      this.setState({
        error,
        isSubmitting: false,
        isShowResult: true,
        isSubmitSuccess: this.getSubmissionResult(),
      });
    } else {
      this.setState({
        error,
        isSubmitting: false,
      });
    }
  };

  renderSubmitBtn = () => {
    const { isSubmitting } = this.state;
    return (
      <div>
        <button
          type="submit"
          className={`btn sign-up-btn ${
            this.isActiveSubmitBtn() ? 'active' : 'inactive'
          } ${this.isDisableSubmitBtn() & 'disabled'}`}
        >
          {isSubmitting && <i className="la la-spinner la-spin" />}Submit
        </button>
      </div>
    );
  };

  renderSignUpForm = () => {
    const { organization, adminName, email, designation, error } = this.state;
    return (
      <div className="col-6 sign-up-container">
        <div className="sign-up">
          <h4>Sign up for 1-month trial</h4>
          <div className="details-container">
            <form noValidate onSubmit={e => this.signUpSubmit(e)}>
              <ValidatedInput
                label={'Organization'}
                name={ORGANIZATION}
                value={organization}
                onChange={this.setFormValue}
                isRequired={true}
                isInvalid={error[ORGANIZATION]}
              />
              <ValidatedInput
                label={'Admin Name'}
                name={'adminName'}
                value={adminName}
                onChange={this.setFormValue}
                isRequired={false}
                isInvalid={error['adminName']}
              />
              <ValidatedInput
                label={'Admin Email'}
                name={EMAIL}
                value={email}
                onChange={this.setFormValue}
                isRequired={true}
                isInvalid={error[EMAIL]}
              />
              <ValidatedInput
                label={'Designation'}
                name={'designation'}
                value={designation}
                onChange={this.setFormValue}
                isRequired={false}
                isInvalid={error['designation']}
              />
              {this.renderSubmitBtn()}
            </form>
          </div>
        </div>
      </div>
    );
  };

  renderSignUpResult = () => {
    return <SignUpResult isSuccess={this.state.isSubmitSuccess} history={this.props.history} />;
  };

  render() {
    return (
      <div className="login-container">
        <div className="col-6 login"> </div>
        {this.state.isShowResult ? this.renderSignUpResult() : this.renderSignUpForm()}
      </div>
    );
  }
}

export default withRouter(SignUp);



// WEBPACK FOOTER //
// ./src/features/login/SignUp.js